import { Assignable } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ tag, assignable, assignableId, project }) => {
    const addTag = {
      [Assignable.TASK]: repository.addTagToTask,
      [Assignable.LIST]: repository.addTagToList,
      [Assignable.MILESTONE]: repository.addTagToMilestone,
      [Assignable.PROJECT]: repository.addTagToProject,
      [Assignable.RESSOURCE]: repository.addTagToResource,
      [Assignable.EVENT]: repository.addTagToEvent,
    };

    return present(
      addTag[assignable]
        ? addTag[assignable](tag, assignableId)
            .then(() => ({ tag, assignable, assignableId, project }))
            .catch(() =>
              Promise.reject({ tag, assignable, assignableId, project }),
            )
        : Promise.reject({ tag, assignable, assignableId, project }),
    );
  };
}

export type { Interactor };

export { createInteractor };
